import { RouteLocationCompositionDTO } from './RouteLocationCompositionDTO';
import { TypedRouteLocationDTO } from './TypedRouteLocationDTO';

export class ScheduledRouteLocationDTO {
    public prediction: number;
    constructor(
        public source: TypedRouteLocationDTO
    ) {}
}
